import '@glidejs/glide/dist/glide.js';
import '@glidejs/glide/src/assets/sass/glide.core.scss';
import '@glidejs/glide/src/assets/sass/glide.theme.scss';

document.addEventListener('DOMContentLoaded', () => {
  const uspBannerSelector = '.glide--usp-banner';
  const uspBannerElement = document.querySelector(uspBannerSelector);

  if (!uspBannerElement) return;

  const uspBannerAutoplay = uspBannerElement.dataset.autoplay;
  const uspBannerDelay = uspBannerElement.dataset.delay;

  let autoplay = false;
  if (uspBannerAutoplay === 'true') {
    autoplay = Number(uspBannerDelay);
  }

  const uspBannerSliderOptions = {
    type: 'carousel',
    limit: 4,
    perView: 1,
    gap: 0,
    peek: {
      before: 0,
      after: 0
    },
    autoplay
  };

  const convertDateForIos = (date) => {
    var arr = date.split(/[- :]/);
    date = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]).getTime();
    return date;
  }

  const setTimer = () => {
    const uspBannerItems = document.querySelectorAll('.usp-banner__item');
    if (uspBannerItems.length > 0) {
      uspBannerItems.forEach((element, index) => {
        const endDay = element.dataset.countdownEndDay.trim();
        const timerInterval = 1000;
        const timerElement = element.querySelector('.usp-banner__countdown');

        if (timerElement && endDay !== '') {
          const setCountdown = () => {
            if (!timerElement) {
              clearInterval(countdownInterval);
            };

            const countDown = convertDateForIos(endDay);
            const second = 1000,
                  minute = second * 60,
                  hour = minute * 60,
                  day = hour * 24;

            // lock time zone
            const c = new Date().toLocaleString('en-US', { timeZone: 'Europe/London' });
            const sensibleFormat = new Date(c);
            const now = sensibleFormat.getTime(),
                distance = countDown - now;

            if (distance <= 0) {
              const contentAfterCountdown = element.querySelector('[data-content-after-countdown]')
              if(contentAfterCountdown) {
                element.innerHTML = contentAfterCountdown.innerHTML;
              } else {
                timerElement.innerHTML = '<b>00h&nbsp;00m&nbsp;00s</b>';
              }
              clearInterval(countdownInterval);
            } else {
              let dayText =  Math.floor(distance / (day));
              let hoursText =  Math.floor((distance % (day)) / (hour)).toString().padStart(2, '0');
              let minutesText =  Math.floor((distance % (hour)) / (minute)).toString().padStart(2, '0');
              let secondText = Math.floor((distance % (minute)) / second).toString().padStart(2, '0');
              let timerHtml = '';

              if (dayText){
                timerHtml = '<b>'+dayText+'</b>d&nbsp;<b>'+hoursText+'</b>h&nbsp;<b>'+minutesText+'</b>m&nbsp;<b>'+secondText+'</b>s';
              } else {
                timerHtml =  '<b>'+hoursText+'h&nbsp;'+minutesText+'m&nbsp;'+secondText+'s</b>';
              }

              if (timerElement) {
                timerElement.innerHTML = timerHtml;
              } else {
                clearInterval(countdownInterval);
              }
            }
          }

          const countdownInterval = setInterval(() => { setCountdown(); }, timerInterval);
          setCountdown();
        }

        setTimeout(() => {
          if (timerElement) {
            timerElement.classList.remove('hidden');
          }
        }, timerInterval)
      });
    }
  }

  let uspBannerSlider = new Glide(uspBannerSelector, uspBannerSliderOptions);
  uspBannerSlider.mount();
  setTimeout(() => {
    setTimer();
  }, 250);

  const reInitUspBannerSlider = () => {
    uspBannerSlider.destroy();
    uspBannerSlider = new Glide(uspBannerSelector, uspBannerSliderOptions);
    uspBannerSlider.mount();
    setTimeout(() => {
      setTimer();
    }, 250);
  };

  window.addEventListener('resize', function() {
    reInitUspBannerSlider();
  });
});
